import { I621Form } from 'legacy/lut/features/partner360/configuration'
import { IVerticalMarket } from 'legacy/lut/features/partner360/marketInfo'

export const map621ToVerticalMarket = (data: I621Form): IVerticalMarket => {
  return {
    isPercentMode: data.VerticalShowPercent === 1,
    centralGovernment: data.VerticalCentralGovernment,
    education: data.VerticalEducation,
    financialServices: data.VerticalFinancialServices,
    healthcare: data.VerticalHealthcare,
    localGovernment: data.VerticalLocalGovernment,
    manufacturing: data.VerticalManufacturing,
    professionalServices: data.VerticalProfessionalServices,
    retail: data.VerticalRetail,
    telecommunications: data.VerticalTelecommunications,
    transportation: data.VerticalTransportation,
    utilities: data.VerticalUtilities,
    others: data.VerticalOthers,
    comment: data.VerticalOthersComment,
  }
}
